
import { Video } from "../types";
import { validateTextField } from "./validateTextField";

export function validateVideos(videos: Video[] = []) {
    const errors: Record<number, any> = {};

    // Máximo permitido
    if (videos.length > 3) {
        return {
            type: "max",
            message: "Você pode adicionar no máximo 3 vídeos.",
        };
    }

    // Validar cada vídeo individualmente
    videos.forEach((video, index) => {
        const videoErrors: any = {};

        const nameError = validateTextField(video.name, "Nome do vídeo", {
            required: video.url ? true : false,
            minLength: 3,
            maxLength: 140,
        });

        const urlError = validateTextField(video.url, "URL do vídeo", {
            required: false,
            minLength: 5,
        });

        if (nameError) {
            videoErrors.name = {
                type: "manual",
                message: nameError,
            };
        }

        if (urlError) {
            videoErrors.url = {
                type: "manual",
                message: urlError,
            };
        }

        if (Object.keys(videoErrors).length > 0) {
            errors[index] = videoErrors;
        }
    });

    return Object.keys(errors).length > 0 ? errors : null;
}
